import { render, staticRenderFns } from "./GiteeSaveModal.vue?vue&type=template&id=6293ad66&"
import script from "./GiteeSaveModal.vue?vue&type=script&lang=js&"
export * from "./GiteeSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeSaveModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeSaveModal.vue
// module id = 2364
// module chunks = 1